import { FC } from 'react';
import {
    CreateContactHelp,
    CreateReturnOrderHelp,
    CreateUserHelp,
    FrequentlyAskedQuestionsHelp,
    IneligibleReturnsHelp,
    IntroductionHelp,
    LocatingCreditMemoHelp,
    ShippingAndPackagingRequirementsHelp,
    UploadReturnOrderHelp,
    UserSetupHelp,
    ViewingContactsHelp,
    ViewingReturnOrderHelp,
    UploadPromotionalClaimHelp,
    UploadContractualClaimHelp,
    ViewClaimsHelp,
    ViewPurchaseOrdersHelp,
    PurchaseOrderReportsHelp,
    ManageUsersHelp,
    ReturnTrackingHelp,
    ReturnReasonHelp,
} from '../components/constructed/Help';

export type HelpPageComponent = FC<SiteHelpCallback>;

export interface SiteHelpCallback {
    callback: (id: string) => any;
}

export interface HelpSection {
    id: string;
    labelKey: string;
    component?: HelpPageComponent;
    children?: HelpSection[];
}

export const HelpSections: HelpSection[] = [
    { id: 'introduction', labelKey: 'introductionHelp_Title', component: IntroductionHelp },
    {
        id: 'users',
        labelKey: 'helpSections_users',
        children: [
            { id: 'user-setup', labelKey: 'introductionHelp_newUserSetup', component: UserSetupHelp },
            { id: 'create-user', labelKey: 'introductionHelp_createNewUser', component: CreateUserHelp },
            { id: 'manage-users', labelKey: 'introductionHelp_manageUsers', component: ManageUsersHelp },
        ],
    },
    {
        id: 'returns',
        labelKey: 'helpSections_returns',
        children: [
            { id: 'create-return', labelKey: 'introductionHelp_createReturnOrder', component: CreateReturnOrderHelp },
            { id: 'upload-return', labelKey: 'introductionHelp_uploadReturnOrder', component: UploadReturnOrderHelp },
            { id: 'view-return', labelKey: 'introductionHelp_viewingReturnOrder', component: ViewingReturnOrderHelp },
            { id: 'add-tracking', labelKey: 'introductionHelp_addTracking', component: ReturnTrackingHelp },
            { id: 'add-return-reason', labelKey: 'introductionHelp_addReturnReason', component: ReturnReasonHelp },
            { id: 'credit-memo', labelKey: 'introductionHelp_locatingCreditMemo', component: LocatingCreditMemoHelp },
            {
                id: 'shipping',
                labelKey: 'introductionHelp_shippingAndPackaging',
                component: ShippingAndPackagingRequirementsHelp,
            },
            { id: 'ineligible', labelKey: 'introductionHelp_ineligibleReturns', component: IneligibleReturnsHelp },
        ],
    },
    {
        id: 'claims',
        labelKey: 'introductionHelp_claims',
        children: [
            {
                id: 'upload-contractual-claim',
                labelKey: 'introductionHelp_uploadContractualClaim',
                component: UploadContractualClaimHelp,
            },
            {
                id: 'upload-promotional-claim',
                labelKey: 'introductionHelp_uploadPromotionalClaim',
                component: UploadPromotionalClaimHelp,
            },
            { id: 'view-claims', labelKey: 'introductionHelp_viewClaims', component: ViewClaimsHelp },
        ],
    },
    {
        id: 'contacts',
        labelKey: 'helpSections_contacts',
        children: [
            { id: 'create-contact', labelKey: 'introductionHelp_createContact', component: CreateContactHelp },
            { id: 'view-contacts', labelKey: 'introductionHelp_viewContacts', component: ViewingContactsHelp },
        ],
    },
    {
        id: 'purchase-orders',
        labelKey: 'helpSections_purchaseOrders',
        children: [
            {
                id: 'view-purchase-orders',
                labelKey: 'introductionHelp_viewPurchaseOrders',
                component: ViewPurchaseOrdersHelp,
            },
            {
                id: 'purchase-order-reports',
                labelKey: 'introductionHelp_purchaseOrderReports',
                component: PurchaseOrderReportsHelp,
            },
        ],
    },
    { id: 'faq', labelKey: 'introductionHelp_faq', component: FrequentlyAskedQuestionsHelp },
];

export const HelpComponentsMap: Record<string, HelpPageComponent> = {};
const buildMap = (sections: HelpSection[]) => {
    sections.forEach((section) => {
        if (section.component) HelpComponentsMap[section.id] = section.component;
        if (section.children) buildMap(section.children);
    });
};
buildMap(HelpSections);
